import ThirdDate from './3rddate';
import Awkward from './awkward';
import Backgrounds from './backgrounds';
import Berta from './berta';
import Bucharest from './bucharest';
import CarryOn from './carryon';
import CleaningDay from './cleaningday';
import Cordiceps from './cordiceps';
import ColourPictures from './colourpictures';
import Editorials from './editorials';
import EindunklesFenster from './eindunklesfenster';
import Grandma from './grandma';
import George from './george';
import HTDWN from './htdwn';
import LMFM from './lmfm';
import Loops from './loops';
import NOTLD from './notld';
import Scarrytales from './scarytales';
import Storms from './storms';
import Storyboards from './storyboards';
import Crayons from './crayons';
import TuuTuuTil from './tuutuutil';
import Skandaloes from './skandaloes';

export default {
  [TuuTuuTil.id]: TuuTuuTil,
  [Skandaloes.id]: Skandaloes,
  [ThirdDate.id]: ThirdDate,
  [Awkward.id]: Awkward,
  [Backgrounds.id]: Backgrounds,
  [Berta.id]: Berta,
  [Bucharest.id]: Bucharest,
  [CarryOn.id]: CarryOn,
  [CleaningDay.id]: CleaningDay,
  [Cordiceps.id]: Cordiceps,
  [ColourPictures.id]: ColourPictures,
  [Editorials.id]: Editorials,
  [EindunklesFenster.id]: EindunklesFenster,
  [Grandma.id]: Grandma,
  [George.id]: George,
  [HTDWN.id]: HTDWN,
  [LMFM.id]: LMFM,
  [Loops.id]: Loops,
  [NOTLD.id]: NOTLD,
  [Scarrytales.id]: Scarrytales,
  [Storms.id]: Storms,
  [Storyboards.id]: Storyboards,
  [Crayons.id]: Crayons
};



// WEBPACK FOOTER //
// ./src/projects/index.js